import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from '../UI/Breadcrumb';

const SEGMENT_LABELS: Record<string, string> = {
  admin: 'Admin',
  members: 'Members',
  payments: 'Payments',
  events: 'Events',
  attendance: 'Meeting Attendance',
  interests: 'Interests',
  'volunteer-hours': 'Volunteer Hours',
  functions: 'Admin Functions',
  imports: 'Imports',
  'admin-tools': 'Admin Tools',
  reconciliation: 'Reconciliation',
  'wizard-test': 'Import Wizard',
};

function formatSegment(segment: string): string {
  return SEGMENT_LABELS[segment] || segment
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export default function AdminBreadcrumb() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  // Only show on admin pages
  if (segments[0] !== 'admin') return null;

  const crumbs = segments.map((segment, index) => ({
    label: formatSegment(segment),
    path: '/' + segments.slice(0, index + 1).join('/'),
    isLast: index === segments.length - 1,
  }));

  return (
    <Breadcrumb className="mb-4 mt-2">
      <BreadcrumbList>
        {crumbs.map((crumb, index) => (
          <React.Fragment key={crumb.path}>
            {index > 0 && <BreadcrumbSeparator />}
            <BreadcrumbItem>
              {crumb.isLast ? (
                <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink href={crumb.path}>{crumb.label}</BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
